import createGeodeticX from './geodeticX.js';
import { createTglTransformFunction } from './tgl-transformer.js';
import type { TglGeodeticXModule, TglTransformFunction } from './tgl.types.js';

export type {
  TglTransformCoordinates,
  TglTransformFunction,
} from './tgl.types.js';

// TODO: This is a duplicate of the TGL implementation in the TileMapPlugin.
// This plugin should probably use the TileMapPlugin instead of duplicating the code.

let geodeticX: TglGeodeticXModule | undefined;
export async function initTgl(): Promise<void> {
  if (!geodeticX) {
    geodeticX = await createGeodeticX();
  }
}

function requireGeodeticX(): TglGeodeticXModule {
  if (!geodeticX) {
    throw new Error('TGL is not initialized; call initTgl() first');
  }
  return geodeticX;
}

export const getTglTransformFunction = (
  csib: ArrayBuffer,
  shiftGrids: Map<string, ArrayBuffer> | undefined
): TglTransformFunction =>
  createTglTransformFunction(
    requireGeodeticX(),
    csib,
    shiftGrids &&
      Array.from(shiftGrids, ([name, data]) => ({
        name,
        data: new Uint8Array(data),
      }))
  );
